// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 22 22", width: "22", height: "22" }, props),
        React.createElement("path", { d: "M7.81945 9.6528C7.55096 9.92129 7.11566 9.92129 6.84718 9.6528C6.57869 9.38432 6.57869 8.94902 6.84718 8.68053L10.5138 5.01386C10.7823 4.74538 11.2176 4.74538 11.4861 5.01386L15.1528 8.68053C15.4213 8.94902 15.4213 9.38432 15.1528 9.6528C14.8843 9.92129 14.449 9.92129 14.1805 9.6528L11.6875 7.15977L11.6875 16.0417C11.6875 16.4214 11.3797 16.7292 11 16.7292C10.6203 16.7292 10.3125 16.4214 10.3125 16.0417L10.3125 7.15977L7.81945 9.6528Z" })));
};
Icon.displayName = 'ArrowUp22x22';
export default Icon;
//# sourceMappingURL=ArrowUp22x22.js.map